<atom-async-data
    class="h-100"
    [isLoading]="isLoading"
    data-cy="document-preview-pane"
>
    @if (filePreview) {
        @switch (MIME_TYPES[filePreview.fileType]) {
            @case ('image') {
                <div
                    class="h-100 d-flex justify-content-center align-items-center"
                >
                    <img
                        class="mw-100 mh-100"
                        [attr.alt]="filePreview.fileName"
                        [attr.src]="filePreview.fileUrl | safeResourceUrl"
                    />
                </div>
            }
            @case ('pdf') {
                <embed
                    class="w-100 h-100"
                    [attr.src]="filePreview.fileUrl | safeResourceUrl"
                    type="application/pdf"
                />
            }
            @default {
                <div
                    class="d-flex h-100 justify-content-center align-items-center"
                >
                    <atom-feature-svg
                        class="col-12"
                        [svg]="FEATURE_SVG.NoListData"
                    >
                        <div class="text-center">
                            <span class="d-block mb-1"
                                >This file format can not be previewed.</span
                            >
                            <button
                                class="btn btn-link text-center"
                                (click)="onDownload()"
                            >
                                Click here to download</button
                            >.
                        </div>
                    </atom-feature-svg>
                </div>
            }
        }
    }

    @if (hasError) {
        <div class="d-flex h-100 justify-content-center align-items-center">
            <atom-feature-svg class="col-12" [svg]="FEATURE_SVG.NoListData">
                <div class="text-center">
                    <span class="d-block mb-1 text-danger"
                        >There was an error previewing the document.</span
                    >
                </div>
            </atom-feature-svg>
        </div>
    }
</atom-async-data>
